import { Home } from 'lucide-react';
import { UserTypes, SYSTEM_USER_RIGHTS } from '@/configs/AppConfig';

export const system_user_api_prefix = '/admapi'
export const app_user_api_prefix = '/api'

const combine = (...strings) => {
    return strings.filter(Boolean).join('');
};

export class MOD_TBL_CALCULATIONS {
    static id = "tbl-calculations"
    static base_path = '/tbl-calculations';
    static route_id = '/:calculationId'
    static base_api = combine(app_user_api_prefix, '/tblCalculations');
    static name = 'Triple Bottom Line Calculation';
    static name_plural = 'Triple Bottom Line Calculations';
    static icon = <Home />;
    static auth = [UserTypes.APP_USER];
    static right = ''
    static routes = {
        list: combine(this.base_path, '/list'),
        edit_name: combine(this.base_path, '/edit-name'),
        mod_edit_name: combine(this.base_path, '/edit-name', this.route_id),
        edit: combine(this.base_path, '/edit', this.route_id),
        mod_edit: combine(this.base_path, '/edit'),
        // details: combine(this.base_path, this.route_id, '/details'),
    }
    static api = {
        table: combine(this.base_api, '/table'),
        checkName: combine(this.base_api, '/checkName'),
        create: combine(this.base_api, '/create'),
        preload: combine(this.base_api, '/preload'),
        detail: combine(this.base_api, '/detail'),
        edit: combine(this.base_api, '/edit'),
        updateData: combine(this.base_api, '/update'),
        aiSuggestion: combine(this.base_api, '/valuation'),
        delete: combine(this.base_api),
    }
}


export class MOD_AUTH {
    static id = "user-auth"
    static system_user_log_in_path = "/su-log-in"
    static app_user_log_in_path = "/log-in"
    static system_user_forgot_password_path = "/su-forgot-password"
    static default_log_in_path = this.app_user_log_in_path
    static system_user_default_path_when_logged_in = "/app-users"
    static app_user_default_path_when_logged_in = MOD_TBL_CALCULATIONS.base_path
    static auth = [UserTypes.GUEST]
    static base_api_app_user = combine(app_user_api_prefix, "/appUsers")
    static api_app_user = {
        auth: combine(this.base_api_app_user, '/auth'),
        logout: combine(this.base_api_app_user, '/logout'),
        reloadRights: combine(this.base_api_app_user, '/reloadRights'),
    }
    static base_api_system_user = combine(system_user_api_prefix, "/systemUsers")
    static api_system_user = {
        auth: combine(this.base_api_system_user, '/auth'),
        logout: combine(this.base_api_system_user, '/logout'),
        reloadRights: combine(this.base_api_system_user, '/reloadRights'),
        getOTP: combine(this.base_api_system_user, '/getOTP'),
        resetPassword: combine(this.base_api_system_user, '/resetPassword'),
    }
}

export class MOD_USER_PROFILE {
    static id = "user-profile"
    static base_path = "/profile"
    static system_user_auth = [UserTypes.SYSTEM_USER]
    static app_user_auth = [UserTypes.APP_USER]
    static right = ''
    static app_user_api_base = combine(app_user_api_prefix, "/appUsers")
    static app_user_api = {
        profile: combine(this.app_user_api_base, '/profile'),
        sendCredentials: combine(this.app_user_api_base, '/sendCredentials'),
    }
    static system_user_api_base = combine(system_user_api_prefix, "/systemUsers")
    static system_user_api = {
        profile: combine(this.system_user_api_base, '/profile'),
        sendCredentials: combine(this.system_user_api_base, '/sendCredentials'),
    }
}

export class MOD_SYSTEM_USER_ROLES {
    static id = "system-user-roles"
    static base_api = combine(system_user_api_prefix, '/systemUserRoles');
    static api = {
        selectList: combine(this.base_api, '/selectList')
    }
}
export class MOD_SDG_CATEGORIES {
    static id = "sdg-categories"
    static base_api = combine(system_user_api_prefix, '/sdgCategories');
    static api = {
        selectList: combine(this.base_api, '/selectList')
    }
}

// MODULES


export class MOD_SDG {
    static id = "sdg"
    static base_path = '/sdg';
    static route_id = '/:sdgId'
    static base_api = combine(system_user_api_prefix, '/sdgs');
    static name = 'SDG';
    static name_plural = 'SDGs';
    static icon = <Home />;
    static auth = [UserTypes.SYSTEM_USER];
    static right = SYSTEM_USER_RIGHTS.SDG
    static routes = {
        list: combine(this.base_path, '/list'),
    }
    static api = {
        table: combine(this.base_api, '/table'),
        detail: combine(this.base_api, '/detail'),
        save: this.base_api,
        delete: this.base_api,
        changeStatus: this.base_api,
        checkNumber: combine(this.base_api, '/checkNumber'),
        checkForDelete: combine(this.base_api, '/checkForDelete'),
        checkName: combine(this.base_api, '/checkName'),
    }
    static app_user_api = {
        selectList: combine(app_user_api_prefix, '/sdgs', '/selectList')
    }
}

export class MOD_SYSTEM_USER {
    static id = "system-user"
    static base_path = '/system-users';
    static route_id = '/:systemUserId'
    static base_api = combine(system_user_api_prefix, '/systemUsers');
    static name = 'System User';
    static name_plural = 'System Users';
    static icon = <Home />;
    static auth = [UserTypes.SYSTEM_USER];
    static right = SYSTEM_USER_RIGHTS.SYSTEM_USER
    static routes = {
        list: combine(this.base_path, '/list'),
    }
    static api = {
        table: combine(this.base_api, '/table'),
        detail: combine(this.base_api, '/detail'),
        save: this.base_api,
        delete: this.base_api,
        changeStatus: this.base_api,
        checkNumber: combine(this.base_api, '/checkNumber'),
        checkForDelete: combine(this.base_api, '/checkForDelete'),
        checkName: combine(this.base_api, '/checkName'),
        checkEmail: combine(this.base_api, '/checkEmail'),
        resetPasswordByAdmin: combine(this.base_api, '/resetPasswordByAdmin'),

        // profile
        profile: combine(this.app_user_api_base, '/profile'),
        changePassword: combine(this.app_user_api_base, '/changePassword'),
        checkPasswordValidity: combine(this.app_user_api_base, '/checkPasswordValidity'),
        sendCredentials: combine(this.app_user_api_base, '/sendCredentials'),
    }
}

export class MOD_APP_USER {
    static id = "app-user"
    static base_path = '/app-users';
    static route_id = '/:appUserId'
    static base_api = combine(system_user_api_prefix, '/appUsers');
    static name = 'App User';
    static name_plural = 'App Users';
    static icon = <Home />;
    static auth = [UserTypes.SYSTEM_USER];
    static right = SYSTEM_USER_RIGHTS.APP_USER
    static routes = {
        list: combine(this.base_path, '/list'),
    }
    static api = {
        table: combine(this.base_api, '/table'),
        detail: combine(this.base_api, '/detail'),
        stats: combine(this.base_api, '/stats'),
        selectList: combine(this.base_api, '/selectList'),
    }
}